import { graphql } from "@/data-access/graphql";
import { NewsAlertSchedulerTableFragment } from "../fragments/news-alerts-fragments";
import { ScheduledBriefingFragment } from "../fragments/scheduled-briefing-fragments";

export const GetScheduledItems = graphql(
  `
  query GetScheduledItems(
    $filters: SchedulerItemFilter
    $pagination: OffsetPaginationInput
  ) {
    schedulerItems(filters: $filters, pagination: $pagination) {
      __typename
      ... on NewsAlertType {
        ...NewsAlertSchedulerTableFragment
      }
      ... on ScheduledBriefingType {
        ...ScheduledBriefingFragment
      }
    }
  }
  `,
  [NewsAlertSchedulerTableFragment, ScheduledBriefingFragment],
);
